import { defineMessages } from 'react-intl';

export const resultCountMessages = defineMessages({
  numberOfSearches: {
    id: 'resultCount.numberOfSearches',
    defaultMessage:
      'Searches: <b>{startNumber}-{endNumber}</b> of <b>{totalRecords}</b>',
  },
  numberOfRecords: {
    id: 'resultCount.numberOfRecords',
    defaultMessage:
      'Records: <b>{startNumber}-{endNumber}</b> of <b>{totalRecords}</b>',
  },
  numberOfItems: {
    id: 'resultCount.numberOfItems',
    defaultMessage: 'Number of items: <b>{count}</b>',
  },
  numberOfProjects: {
    id: 'resultCount.numberOfProjects',
    defaultMessage: 'Number of projects: <b>{count}</b>',
  },
  items: {
    id: 'resultCount.items',
    defaultMessage:
      'Items: <b>{startNumber}-{endNumber}</b> of <b>{totalRecords}</b>',
  },
});
